<section class="container">
  <div class="header-wrapper">
    <h1>Localisation</h1>
  </div>
  <div class="content-wrapper">
    <a data-qa-id="localisation-btn-update-translations" mat-raised-button class="mat-primary" (click)="fileUpload.click()">
      <mat-icon>cloud_upload</mat-icon><span class="btn-label">Update Translations</span>
    </a>
    <input #fileUpload id="file-upload" type="file" accept=".csv" multiple="multiple" (change)="handleFileInput($event.target.files); fileUpload.value = ''" />
    <a data-qa-id="localisation-btn-download" mat-raised-button class="mat-primary" (click)="download()">
      <mat-icon>cloud_download</mat-icon><span class="btn-label">Download</span>
    </a>
    @if (error.length > 0) {
      <ul class="error-list">
        @for (e of error; track e) {
          <li>
            <pre>{{e | json}}</pre>
          </li>
        }
      </ul>
    }
    @if (translationsModel) {
      <table data-qa-id="localisation-table-translations" class="mdl-data-table">
        <thead>
          <tr>
            <th>
              Label Code
            </th>
            <th>
              Language Code
            </th>
            <th>
              translation
            </th>
            <th>
              <!-- submit/clear buttons -->
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="translation-row">
            <td>
              <input matInput data-qa-id="localisation-input-new-label-code" type="text" placeholder="Label Code" [(ngModel)]="newTranslation.labelCode" name="new-translation-label-code" required />
            </td>
            <td>
              <input matInput data-qa-id="localisation-input-new-language-code" type="text" placeholder="Language Code" [(ngModel)]="newTranslation.languageCode" name="new-translation-language-code" required />
            </td>
            <td>
              <input matInput data-qa-id="localisation-input-new-translation" type="text" placeholder="Translation" [(ngModel)]="newTranslation.translation" name="new-translation-translation" required />
            </td>
            <td>
              <div [style.visibility]="newTranslationIsValid() ? 'visible' : 'hidden'">
                <a data-qa-id="localisation-btn-add-translation" mat-raised-button class="mat-primary tableBtn" (click)="addLocalisation()">
                  <mat-icon>done</mat-icon>
                </a>
              </div>
            </td>
          </tr>
          @for (translation of translationsModel; track translation) {
            <tr class="translation-row {{translation.TranslationMissing ? 'missing-value' : 'has-value'}}">
              <td>
                {{translation.labelCode}}
              </td>
              <td>
                {{translation.languageCode}}
              </td>
              <td>
                <input matInput type="text" placeholder="translation ({{translation.languageCode}})" [(ngModel)]="translation.translation" name="translation-{{translation.languageCode}}" required />
              </td>
              <td>
                <div [style.visibility]="hasModification(translation) ? 'visible' : 'hidden'">
                  <a mat-raised-button class="mat-primary tableBtn" (click)="reset(translation)">
                    <mat-icon>clear</mat-icon>
                  </a>
                  <a mat-raised-button class="mat-primary tableBtn" (click)="updateLocalisation(translation)">
                    <mat-icon>done</mat-icon>
                  </a>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</section>